import { Button, Container, Group, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';

import { CloseIndicator } from '@mygpt/app';

import classes from './index.module.css';

export function NotFoundPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const recovered = (searchParams.get('r') || '1') === '1';

  return (
    <Container className={classes.root}>
      <CloseIndicator />
      <div className={classes.label}>{t('errors.notfound.label')}</div>
      <Title className={classes.title}>{t('errors.notfound.title')}</Title>
      <Text color="dimmed" size="lg" ta="center" className={classes.description}>
        {t('errors.notfound.description')}
      </Text>
      {recovered && (
        <Group justify="center">
          <Button variant="subtle" size="md" component={Link} to="/">
            {t('errors.notfound.button')}
          </Button>
        </Group>
      )}
    </Container>
  );
}
